module.exports = __webpack_public_path__ + "static/media/nivel 4_400.a3433824.jpg";